import {
  createStyles,
  withStyles,
  Theme,
  makeStyles,
} from '@material-ui/core/styles'

import { TableCell, Switch } from '@material-ui/core'
import { theme } from '..'

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
      borderBottomColor: '#464646',
    },
    body: {
      fontSize: 14,
      paddingBottom: '5px',
      paddingTop: '5px',
    },
  })
)(TableCell)

const RipleySwitch = withStyles(() =>
  createStyles({
    switchBase: {
      color: theme.purple,
      '&$checked': {
        color: theme.purple,
      },
      '&$checked + $track': {
        backgroundColor: theme.purple,
      },
    },
    body: {
      fontSize: 14,
      borderBottom: 'none',
    },
  })
)(Switch)

const styleOverride = makeStyles({
  table: {
    minWidth: 700,
  },
  header: {
    fontSize: 14,
    borderColor: '#464646',
    borderBottomWidth: '1.2px',
    fontWeight: 500,
  },
  indexRow: {
    padding: '1rem',
  },
  gruopCell: {
    width: '4rem',
  },
})

export { styleOverride as default, StyledTableCell, RipleySwitch }
